<template>
  <div class="addReportDialog">
    <el-dialog
      :title="title"
      :visible.sync="dialog"
      :close-on-click-modal="false"
      top="58vh"
      width="60%"
      :style="{ height: '850px' }"
      class="scrollbar exportFrom dialogFrom"
    >
      <div class="dialogContent">
        <el-form
          label-width="120px"
          class="qcFrom dialogScoped"
          ref="setExportFrom"
          :model="dialogList"
          :rules="rules"
        >
          <el-form-item label="机构名称：" prop="HospitalGuid">
            <el-select
              v-model="dialogList.HospitalGuid"
              placeholder="请选择机构"
              class="multiple"
              filterable
              @change="changeHospital"
            >
              <el-option
                v-for="item in allHospitalsData"
                :key="item.HospitalGuid"
                :label="item.HospitalName"
                :value="item.HospitalGuid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="检查号：" prop="AccNo">
            <el-input
              v-model="dialogList.AccNo"
              size="small"
              placeholder="请输入检查号"
            ></el-input>
          </el-form-item>
          <el-form-item label="患者编号：" prop="PatientNo">
            <el-input
              v-model="dialogList.PatientNo"
              size="small"
              placeholder="请输入患者编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="患者姓名：" prop="PatientName">
            <el-input
              v-model="dialogList.PatientName"
              size="small"
              placeholder="请输入患者姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="患者性别：" prop="Gender">
            <el-select
              v-model="dialogList.Gender"
              size="small"
              placeholder="请选择患者性别"
            >
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
              <el-option label="未知" value="未知"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄(岁)：" prop="CurrentAge">
            <el-input
              v-model="dialogList.CurrentAge"
              size="small"
              placeholder="请输入年龄"
            ></el-input>
          </el-form-item>
          <el-form-item label="模态：" prop="ModalityType">
            <el-select
              size="small"
              v-model="dialogList.ModalityType"
              style="width: 100%;"
              placeholder="请选择模态"
            >
              <el-option
                v-for="(item, index) in modalityTypeSelect"
                :key="index"
                :label="item.Name"
                :value="item.Name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="检查项目：" prop="CheckingItems">
            <el-input
              v-model="dialogList.CheckingItems"
              size="small"
              placeholder="请输入检查项目"
            ></el-input>
          </el-form-item>
          <el-form-item label="扫描方式：" prop="ScanTypes">
            <el-select
              size="small"
              v-model="dialogList.ScanTypes"
              style="width: 100%;"
              placeholder="请选择扫描方式"
            >
              <el-option
                v-for="(item, index) in scanTypeSelect"
                :key="index"
                :label="item.Name"
                :value="item.Name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部位：" prop="BodyParts">
            <el-select
              size="small"
              v-model="dialogList.BodyParts"
              style="width: 100%;"
              filterable
              placeholder="请选择检查部位"
            >
              <el-option
                v-for="item in detailsRulesParameter.BodyPart"
                :key="item.text"
                :label="item.text"
                :value="item.text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="影像所见：" prop="WysText">
            <el-input
              v-model="dialogList.WysText"
              type="textarea"
              placeholder="请输入影像所见"
            ></el-input>
          </el-form-item>
          <el-form-item label="影像诊断：" prop="WygText">
            <el-input
              v-model="dialogList.WygText"
              type="textarea"
              placeholder="请输入影像诊断"
            ></el-input>
          </el-form-item>
          <el-form-item label="阴阳性：" prop="IsPositive">
            <el-select
              v-model="dialogList.IsPositive"
              size="small"
              placeholder="请选择阴阳性"
            >
              <el-option label="阳性" value="1"></el-option>
              <el-option label="阴性" value="2"></el-option>
              <el-option label="未知" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="病史：" prop="HealthHistory">
            <el-input
              v-model="dialogList.HealthHistory"
              type="textarea"
              placeholder="请输入病史"
            ></el-input>
          </el-form-item>
          <el-form-item label="报告提交时间：" prop="ReportSubmitDt">
            <el-date-picker
              v-model="dialogList.ReportSubmitDt"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择报告提交时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="提交人姓名：" prop="ReportSubmitterName">
            <el-input
              v-model="dialogList.ReportSubmitterName"
              size="small"
              placeholder="请输入提交人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="报告审核时间：" prop="FirstApproveDt">
            <el-date-picker
              v-model="dialogList.FirstApproveDt"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择报告审核时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="审核人姓名：" prop="FirstApproverName">
            <el-input
              v-model="dialogList.FirstApproverName"
              size="small"
              placeholder="请输入审核人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="检查时间：" prop="ExaminDate">
            <el-date-picker
              v-model="dialogList.ExaminDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择检查时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="技师姓名：" prop="TechnicianName">
            <el-input
              v-model="dialogList.TechnicianName"
              size="small"
              placeholder="请输入技师姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm" :loading="btnLoading">
              提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Api from "../../../api";
import axios from "@/js/api";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      btnLoading: false,
      title: "新增报告",
      allHospitalsData: [],
      dialogList: {
        HospitalGuid: "",
        AccNo: "",
        PatientNo: "",
        PatientName: "",
        Gender: "",
        CurrentAge: "",
        ModalityType: "",
        WysText: "",
        WygText: "",
        IsPositive: "",
        HealthHistory: "",
        ReportSubmitDt: "",
        ReportSubmitterName: "",
        FirstApproveDt: "",
        FirstApproverName: "",
        ExaminDate: "",
        TechnicianName: "",
      },
      scanTypeSelect: [],
      modalityTypeSelect: [],
      rules: {
        HospitalGuid: [
          { required: true, message: "请选择机构", trigger: "blur" },
        ],
        AccNo: [{ required: true, message: "请输入检查号", trigger: "blur" }],
        PatientNo: [
          { required: false, message: "请输入患者编号", trigger: "blur" },
        ],
        PatientName: [
          { required: false, message: "请输入患者姓名", trigger: "blur" },
        ],
        Gender: [
          { required: true, message: "请选择患者性别", trigger: "blur" },
        ],
        CurrentAge: [
          { required: true, message: "请输入年龄", trigger: "blur" },
        ],
        ModalityType: [
          { required: true, message: "请选择模态", trigger: "blur" },
        ],
        CheckingItems: [
          { required: true, message: "请输入检查项目", trigger: "blur" },
        ],
        ScanTypes: [
          { required: true, message: "请输入扫描方式", trigger: "blur" },
        ],
        BodyParts: [{ required: true, message: "请输入部位", trigger: "blur" }],
        WysText: [
          { required: true, message: "请输入影像所见", trigger: "blur" },
        ],
        WygText: [
          { required: true, message: "请输入影像诊断", trigger: "blur" },
        ],
        IsPositive: [
          { required: true, message: "请选择阴阳性", trigger: "blur" },
        ],
        HealthHistory: [
          { required: false, message: "请输入病史", trigger: "blur" },
        ],
        ReportSubmitDt: [
          { required: true, message: "请选择报告提交时间", trigger: "blur" },
        ],
        ReportSubmitterName: [
          { required: true, message: "请输入提交人姓名", trigger: "blur" },
        ],
        FirstApproveDt: [
          { required: true, message: "请选择报告审核时间", trigger: "blur" },
        ],
        FirstApproverName: [
          { required: true, message: "请输入审核人姓名", trigger: "blur" },
        ],
        ExaminDate: [
          { required: true, message: "请选择检查时间", trigger: "blur" },
        ],
        TechnicianName: [
          { required: true, message: "请输入技师姓名", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...Vuex.mapState("breadcrumb", ["detailsRulesParameter"]),
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("change", val);
      },
    },
  },
  created() {
    this.getAllHospitals();
    this.GetReportModality();
    this.GetBodyParts();
    this.getGetReportScanType();
  },
  methods: {
    ...Vuex.mapActions("breadcrumb", ["GetBodyParts"]),
    changeHospital(val) {
      console.log(val, "val");
      this.dialogList.HospitalGuid = val;
      this.dialogList.HospitalName = this.allHospitalsData.find(
        (item) => item.HospitalGuid === val
      ).HospitalName;
    },
    GetReportModality() {
      axios.ajaxGet("get", Api.api.manager.GetReportModality).then((res) => {
        if (res.status == 200 && res.data.StatusCode == 200) {
          this.modalityTypeSelect = res.data.Data;
        }
      });
    },
    getAllHospitals() {
      axios
        .ajaxGet("get", Api.api.manager.GetHandReportHospital)
        .then((res) => {
          console.log(res, "sss");
          if (res.status == 200 && res.data.StatusCode == 200) {
            this.allHospitalsData = res.data.Data;
          }
        });
    },
    getGetReportScanType() {
      axios.ajaxGet("get", Api.api.manager.GetReportScanType).then((res) => {
        if (res.status == 200 && res.data.StatusCode == 200) {
          this.scanTypeSelect = res.data.Data;
        }
      });
    },
    submitForm() {
      this.btnLoading = true;
      this.$refs.setExportFrom.validate((valid) => {
        if (valid) {
          console.log(this.dialogList);
          let params = {
            ...this.dialogList,
          };

          let ApiRequest = this.dialogList.ReportGuid
            ? Api.api.manager.updateReportHand
            : Api.api.manager.addReportHand;
          axios
            .ajaxPost("post", ApiRequest, params)
            .then((res) => {
              this.btnLoading = false;
              if (res.status == 200 && res.data.StatusCode == 200) {
                this.$message.success("提交成功");
                this.$emit("updateList");
                this.dialog = false;
              } else {
                this.$message.error(res.data.Message);
              }
            })
            .catch(() => {
              this.btnLoading = false;
            });
        } else {
          this.btnLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.addReportDialog {
  ::v-deep .el-dialog {
    top: 48%;
    height: 700px;
    margin-top: -350px;
  }
  ::v-deep .el-input__prefix {
    left: initial;
  }
}
</style>
